import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { WeddingComponent } from './wedding/wedding.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { RegistryComponent } from './registry/registry.component';
import { ContactComponent } from './contact/contact.component';

const appRoutes: Routes = [
    {
      path: '',
      redirectTo: 'home',
      pathMatch: 'full'
    },
    {
      path: 'home',
      component: HomeComponent
    },
    {
      path: 'about',
      component: AboutComponent
    },
    {
      path: 'wedding',
      component: WeddingComponent
    },
    {
      path: 'registry',
      component: RegistryComponent
    },
    // {
    //   path: 'contact',
    //   component: ContactComponent
    // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        // enableTracing: true
      }
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [
    // CanDeactivateGuard,
    // SelectivePreloadingStrategy
  ]
})
export class AppRoutingModule { }


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts